var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_download_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2635",
    "data-name": "Group 2635"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3944",
    "data-name": "Rectangle 3944",
    width: 21,
    height: 21,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2636",
    "data-name": "Group 2636",
    transform: "translate(3.5 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10894",
    "data-name": "Path 10894",
    d: "M16.25,13.625V16.25H5.75V13.625H4V16.25A1.755,1.755,0,0,0,5.75,18h10.5A1.755,1.755,0,0,0,18,16.25V13.625Zm-.875-3.5L14.141,8.891l-2.266,2.257V4h-1.75v7.149L7.859,8.891,6.625,10.125,11,14.5Z",
    transform: "translate(-4 -4)",
    fill: "#4eb6ee"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownloadIcon);
export default __webpack_public_path__ + "static/media/file_download_Icon.61c7a78b0256a3d5a37c89c4c6657ece.svg";
export { ForwardRef as ReactComponent };